import { render, staticRenderFns } from "./WallLeaderboard.vue?vue&type=template&id=50bcb9bf&scoped=true&"
import script from "./WallLeaderboard.vue?vue&type=script&lang=js&"
export * from "./WallLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./WallLeaderboard.vue?vue&type=style&index=0&id=50bcb9bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bcb9bf",
  null
  
)

export default component.exports